import { jsx as E } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { memo as u } from "../../../../../external/preact/compat/dist/compat.module.js";
import { propsProperty as w, property as n } from "./utils.js";
import { CalendarGridRenderToken as y } from "../../types.js";
import { memoComparator as N } from "../../../../../utils/preact/memoComparator/main.js";
import { fixedForwardRef as O } from "../../../../../utils/preact/fixedForwardRef.js";
import { getClassName as l } from "../../../../../utils/preact/className.js";
import { EMPTY_OBJECT as i } from "../../../../../utils/value/constants.js";
const T = "adyen-pe-calendar__cell adyen-pe-calendar__cell--date", _ = "adyen-pe-calendar__date", P = (a = i, r) => {
  const d = w.unwrapped(
    {
      childClassName: n.mutable(_),
      childProps: {
        children: n.restricted(),
        className: ""
      },
      className: n.mutable(T),
      props: {
        ...a,
        children: n.restricted(),
        className: ""
      }
    },
    !0
  );
  return r == null || r(y.DATE, d), d;
}, G = O(
  ({ grid: a, prepare: r, datetime: d, flags: e, index: m, label: p, onlyCellsWithin: C }, h) => {
    const s = e.WITHIN_BLOCK, t = {
      "data-cursor-position": m,
      "data-within-month": s,
      tabIndex: -1
    };
    if (s) {
      const c = e.WITHIN_RANGE;
      t["data-today"] = e.CURRENT, t["data-first-week-day"] = e.LINE_START, t["data-last-week-day"] = e.LINE_END, t["data-weekend"] = e.WEEKEND, t["data-first-month-day"] = e.BLOCK_START, t["data-last-month-day"] = e.BLOCK_END, t["data-within-range"] = c, c && (t["data-range-end"] = e.RANGE_END, t["data-range-start"] = e.RANGE_START, t["data-selection-end"] = e.SELECTION_END, t["data-selection-start"] = e.SELECTION_START, t["data-within-selection"] = e.WITHIN_SELECTION, t["aria-selected"] = `${!!(e.SELECTION_END || e.SELECTION_START || e.WITHIN_SELECTION)}`), m === +a.cursor && (t.ref = h);
    }
    const o = P(t, r), { children: x, className: I, ...A } = o.props || i, L = l(o.className, T, I);
    return /* @__PURE__ */ E("td", { ...A, ...t, className: L, children: (!C || s) && (() => {
      const {
        children: c,
        className: S,
        ...D
      } = o.childProps || i, R = l(o.childClassName, _, S);
      return /* @__PURE__ */ E("time", { ...D, className: R, dateTime: d, children: p });
    })() });
  }
), F = u(
  G,
  N({
    block: N.exclude,
    flags: (a) => +a
  })
);
export {
  F as default
};
